import { SearchDocumentType, } from '../../api/api.types';
import { getDemoSearchResults } from './searchResults';
import { getTotalCount } from './getTotalCount';
var PAGE_SIZE = 10;
var SEARCH_RESULTS_EMPTY_RESPONSE = {
    documents: [],
    nextPage: { total: 0, skip: 0, limit: PAGE_SIZE },
    facets: [],
};
export function getDemoSearchResponse(searchRequest, _a) {
    var shouldHaveSearchResults = _a.shouldHaveSearchResults;
    if (!shouldHaveSearchResults) {
        return SEARCH_RESULTS_EMPTY_RESPONSE;
    }
    var documentType = searchRequest.documentType || SearchDocumentType.All;
    var totalCount = getTotalCount(documentType);
    var skip = (searchRequest.paging && searchRequest.paging.skip) || 0;
    var limit = Math.min(totalCount - skip, (searchRequest.paging && searchRequest.paging.limit) || PAGE_SIZE);
    return {
        documents: getDemoSearchResults({
            documentType: documentType,
            limit: limit,
            skip: skip,
            query: searchRequest.query,
        }),
        nextPage: { total: totalCount, skip: 0, limit: limit },
        facets: [],
    };
}
//# sourceMappingURL=searchResponse.js.map